import React, { useState, useEffect } from 'react';
import { Nav, NavItem, NavLink, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Navbar, Container, NavbarBrand, NavbarToggler, UncontrolledCollapse } from 'reactstrap';
import Headroom from 'headroom.js';
import classnames from 'classnames';

const ReactNav = ({ className, children, ...rest }) => {
  return /* @__PURE__ */ React.createElement(Nav, {
    className,
    navbar: true,
    ...rest
  }, children);
};

const ReactNavLink = ({ className, children, href, ...rest }) => {
  let navClss = classnames("", className);
  return /* @__PURE__ */ React.createElement(NavItem, {
    className: navClss
  }, /* @__PURE__ */ React.createElement(NavLink, {
    href,
    ...rest
  }, children));
};

const ReactDropDown = ({ label, options }) => {
  return /* @__PURE__ */ React.createElement(UncontrolledDropdown, {
    nav: true,
    inNavbar: true
  }, /* @__PURE__ */ React.createElement(DropdownToggle, {
    nav: true,
    caret: true
  }, label), /* @__PURE__ */ React.createElement(DropdownMenu, {
    right: true
  }, options.map((option, idx) => /* @__PURE__ */ React.createElement(DropdownItem, {
    key: idx,
    header: option.header,
    divider: option.divider
  }, /* @__PURE__ */ React.createElement(NavLink, {
    href: option.href
  }, option.label && (!option.divider || option.header) && option.label)))));
};

const ReactNavbar = ({ id, brand, children, tag, ...rest }) => {
  const [collapseClss, setCollapseClss] = useState("");
  useEffect(() => {
    const element = document.getElementById(id);
    if (element) {
      let headroom = new Headroom(element);
      headroom.init();
    }
  }, []);
  const onExited = () => setCollapseClss("");
  const onExiting = () => setCollapseClss("collapsing-out");
  return /* @__PURE__ */ React.createElement("header", {
    className: "header"
  }, /* @__PURE__ */ React.createElement(Navbar, {
    id,
    ...rest
  }, /* @__PURE__ */ React.createElement(Container, null, brand && (tag ? /* @__PURE__ */ React.createElement(NavbarBrand, {
    to: "/",
    tag
  }, brand) : /* @__PURE__ */ React.createElement(NavbarBrand, {
    href: "/"
  }, brand)), /* @__PURE__ */ React.createElement(NavbarToggler, {
    id: "navbar_toggler"
  }), /* @__PURE__ */ React.createElement(UncontrolledCollapse, {
    navbar: true,
    toggler: "#navbar_toggler",
    className: collapseClss,
    onExiting,
    onExited
  }, children))));
};
ReactNavbar.defaultProps = {
  id: "main-navbar"
};

export { ReactDropDown as Dropdown, ReactNav as Nav, ReactNavLink as NavLink, ReactNavbar as default };
//# sourceMappingURL=index.es.js.map
